<template>
  <div class="layout">
    <h2>聚光燈外的世界</h2>
    <div class="section">
      <div class="card" v-for="(item, index) in news" :key="index">
        <!-- <img class="card_img" :src="item.Url" alt="" srcset="" loading="lazy"> -->
        <a :href="'https://www.ftvnews.com.tw/news/detail/' + item.Url" target="_blank" class="card_a">
          <p class="card_tag2" :href="'https://www.ftvnews.com.tw/tag/' + item.Tag">#{{ item.Tag }}</p>
          <img class="card_img" :src="'https://www.ftvnews.com.tw/topics/taiwanband/img/' + item.Img + '.jpg'">
          <p>{{ item.Title }}</p>
        </a>
        <div class="tag">
          <a class="card_tag" :href="'https://www.ftvnews.com.tw/tag/' + item.Tag2" target="_blank">#{{ item.Tag2 }}</a>
          <a class="card_tag" :href="'https://www.ftvnews.com.tw/tag/' + item.Tag3" target="_blank">#{{ item.Tag3 }}</a>
        </div>
      </div>
    </div>
    <div id="spotlight"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      news: [
        { Title: '藝文產業有多難生存？專訪「樂悠悠之口」談LiveHouse現況', Url: '2023330W0330', Tag: 'LiveHouse經營', Tag2: '空間', Tag3: '展演', Img: '樂悠悠之口' },
        { Title: '高雄樂團的夢想起點「百樂門」探討LiveHouse的獨特性', Url: '2023330W0345', Tag: 'LiveHouse經營', Tag2: '高雄', Tag3: '藝文產業', Img: '百樂門' },
        { Title: '辦音樂祭遇颱風、破產負債三千萬！山海屯創辦人談風光活動背後的血淚史', Url: '2023328W0198', Tag: '活動策畫', Tag2: '音樂祭', Tag3: '藝文產業', Img: '島楎B' },
        { Title: '音樂祭與專場有何不同？活動廠牌主理人：音樂祭是入門、專場是深度體驗', Url: '2023328W0185', Tag: '活動策畫', Tag2: '衝撞', Tag3: '開圈', Img: '島楎A' },
        { Title: '看表演哪裡音場最好？專訪音控師林忌何 揭露LIVE演出音樂秘辛', Url: '2023330W0329', Tag: '音控', Tag2: '聲音', Tag3: '音場', Img: '林忌何' },
        { Title: '不只閃爍而已！專訪燈光師陳奕勳 帶你窺探舞台燈光難在哪', Url: '2023330W0326', Tag: '燈控', Tag2: '舞台燈光', Tag3: '空間', Img: '陳奕勳' },
        { Title: '按下快門難在哪？專訪攝影師小辣ShoLar 如何將躁動化為永恆', Url: '2023330W0341', Tag: '攝影', Tag2: '攝影記錄', Tag3: '快門', Img: '小辣' },
        // 其他新聞數據...
      ]
    }
  }
}
</script>


<style scoped>
.card_img {
  height: 200px;
  width: 100%;
  object-fit: cover;
}

.section {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem;
  margin: 1rem auto;
  max-width: 1300px;
}

@media screen and (max-width:900px) {
  .section {
    grid-template-columns: 1fr 1fr 1fr;
  }

}


@media screen and (max-width:768px) {
  .section {
    display: flex;
    gap: 1.5rem;
    margin: 1rem auto;
    overflow-x: scroll;

  }

}


.section_left button {
  margin-right: 0rem;
}

.section img {
  border-radius: 30px 30px 0px 30px;
  width: 100%;
}


@media screen and (max-width:768px) {
  .section img {
    border-radius: 30px 30px 0px 30px;
    width: 250px;

  }

}

.card {
  margin: 1rem auto;
  width: 100%;
}


.card p {
  font-weight: 600;
  line-height: 24px;
  /* or 150% */
  margin: .5rem auto;
  text-align: justify;

}

.tag {
  display: flex;
  flex-direction: row;

}

.card_tag {
  background: #FBB91C;
  margin-right: .5rem;
  padding: .5rem;
  font-weight: bold;
}

.imgtag {
  background: #FBB91C;
  margin-right: .5rem;
  padding: .5rem;
  font-weight: bold;
  width: fit-content;
  position: ab;
  right: -17.5rem;
}


.card_tag2 {
  background: #FBB91C;
  padding: .5rem;
  font-weight: bold;
  font-size: 1.2rem;
  position: absolute;
  top: -33.5px;
  right: 0px;
}



@media screen and (max-width:768px) {
  .card_tag2 {
    font-size: 1.1rem;
    right: 0px;
    top: -33px;
  }

  .card_img {
    height: 150px;
    width: 100%;
    object-fit: cover;
  }

}

.card_a {
  position: relative;
}
</style>
